<div class="inline-message" [ngClass]="type">
  <mat-icon class="inline-message-icon" [color]="type">
    {{ icon }}
  </mat-icon>
  <div class="inline-message-content">
    <div class="title">{{ title }}</div>
    <div class="description">{{ description }}</div>
    <div class="note" *ngIf="note">{{ note }}</div>
  </div>
</div>
